<form class="form autocomplete " [ngClass]="{ 'form--required': !optional }" (blur)="handleBlurr()" tabindex="0">

  <label for="" [ngClass]="optional ? 'custom-label' : 'label'">
    {{title}}
    <app-tooltip *ngIf="tooltip" [text]="tooltip"></app-tooltip>
  </label>
  <h6 class="txt txt--paragraph">{{textInformation}}</h6>
  <div *ngIf="shouldShowArrow" class="arrow">
    <img src="assets/img/arrow_g_d_small.png">
  </div>
  <div class="decorator-container" *ngIf="isLoading">
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </div>
  <input
    type="text"
    autocomplete="off"
    [ngClass]="{
      'form--white' : color === 'white'
    }"
    [attr.placeholder]="placeHolder"
    [formControl]="textInputValue"
    (focus)="handleFocus()"
    (ngModelChange)="onTextInputChange($event)"
    (keypress)="alphaNumberOnly($event)"
    (paste)="onPaste($event)"
  />
  <h6 class="form__info">{{hintText}}</h6>
  <ng-container *ngIf="behavior === 'ON_TEXT_CHANGE'">
    <div id="iexampleautocomplete-list" class="autocomplete-items corrected-backgroud-and-overflow"
      *ngIf="filteredOptionList.length > 0 && textInputValue.value && focus">
      <div [id]="option.id" (click)="onSelectValue($event)" *ngFor="let option of filteredOptionList">
        {{option.value}}<input [ngClass]="{
          'form--white' : color === 'white'
        }" type="hidden" [value]="option.id" /></div>
    </div>
  </ng-container>

  <ng-container *ngIf="behavior === 'ON_FOCUS'">
    <div id="iexampleautocomplete-list" class="autocomplete-items corrected-backgroud-and-overflow " [ngClass]="{
      'bigger-option-space': biggerOptionSpace,
      'bigger-option-width': biggerOptionWidth
    }" *ngIf="filteredOptionList.length > 0 && focus">
      <div [id]="option.id" (click)="onSelectValue($event)" *ngFor="let option of filteredOptionList">
        {{option.value}}<input [ngClass]="{
          'form--white' : color === 'white'
        }" type="hidden" [value]="option.id" /></div>
    </div>
  </ng-container>

</form>
